module.exports = "/images/login-user.jpg?27fec8aa0cde998a506b336484b7ef85";